export const getUserEmailFromLocalStorage = (): string | null => {
  return localStorage.getItem("userEmail");
};
